module.exports = __webpack_public_path__ + "images/mdj/members/common/pagetop-green-0f6bf2c6f3bcbe3b17a2b522a161b99e.png";